import { render } from "./UiLogo.vue?vue&type=template&id=a0fe8a78&scoped=true&lang=pug"
import script from "./UiLogo.vue?vue&type=script&lang=js"
export * from "./UiLogo.vue?vue&type=script&lang=js"

import "./UiLogo.vue?vue&type=style&index=0&id=a0fe8a78&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0fe8a78"]])

export default __exports__